function InputDataMesSemLabel({ dataFim, setData, mesMinimo }) {

    const handleChange = (event) => {

        if (dataFim === 'true') {
            const dataSplit = event.target.value.split('-');
            const ultimoDiaDoMes = new Date(dataSplit[0], (dataSplit[1] - 1) + 1, 0).getDate();
            setData(`${event.target.value}-${ultimoDiaDoMes}`)

        } else {

            if (event.target.value) {
                setData(`${event.target.value}-01`)
            } else {
                setData(null)
            }

        }
    };

    console.log('### Iniciando Input Data Mes Sem Label ###');

    return (
        <input className='form-control form-control-sm text-center' type="month" onChange={handleChange} required />
    )
}

export default InputDataMesSemLabel